import React from 'react';

import block from 'propmods';

import { GrammarPageEntitiesSection } from '../GrammarPageEntitiesSection/GrammarPageEntitiesSection';
import { GrammarPageIntentsSection } from '../GrammarPageIntentsSection/GrammarPageIntentsSection';

import './GrammarPage.scss';

const b = block('GrammarPage');

export const GrammarPage: React.FC = () => {
    return (
        <div {...b()}>
            <section {...b('section')}>
                <GrammarPageIntentsSection />
            </section>
            <section {...b('section')}>
                <GrammarPageEntitiesSection />
            </section>
        </div>
    );
};
